
define('text!templates/tabItem.html',[],function () { return '<div class="tab_item {{itemClass}}" id="{{linkId}}"></div>';});

